import Vue from 'vue'
import axios from 'axios'
import store from './store'
// import router from './router'

// Request interceptor
axios.interceptors.request.use((request) => {
  store.commit('main/pStart')

  return request
})

const checkError = (status, message, res) => {
  Vue.prototype.$error(message)
  return Promise.reject(res)
}

const createData = (status, message, response) => {
  Vue.prototype.$success(message)
  return response
}

// Response interceptor
axios.interceptors.response.use(
  (response) => {
    store.commit('main/pEnd')
    if (+response.status == 201) {
      const { code = 201 } = response.data ? response.data : {}
      const { message = 'Aksi berhasil dilakukan' } = response.data ? response.data : {}
      return createData(code, message, response)
    }
    // else
    return response
  },
  (error) => {
    if (!error.response) {
      alert('Periksa koneksi internet Anda.')
    }

    const originalRequest = error.config

    store.commit('main/pEnd')
    const { status = 500 } = error.response ? error.response : {}

    var { message = 'Unknown error' } = error.response ? error.response.data : {}

    if (typeof error.response.data == 'string') {
      message = error.response.data
    }

    return checkError(status, message, error.response.data, originalRequest)
  }
)
